// OWNER: HELP. In-app help center. Content lives in src/help/content/*.md.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/help')({
  staticData: { crumb: 'Help' },
  component: Outlet,
})
